export default __webpack_public_path__ + "static/media/bg-notifications.678d4e7d.jpg";